import React from "react";

interface Props {
	inputValue: string;
	onInputChange: (value: string) => void;
	onProcess: () => void;
}

const LineItemTopInput: React.FC<Props> = ({ inputValue, onInputChange, onProcess }) => {
	return (
		<div className="w-full h-[200px] px-80 bg-slate-700 flex-col justify-center items-center gap-6 inline-flex">
			<img className="w-[1605px] h-[200px]  mix-blend-soft-light absolute" src="/assets/ui/toolbg.png" style={{ pointerEvents: "none" }} />
			<div className="text-center text-white text-base font-semibold font-['Hanken Grotesk'] leading-snug whitespace-nowrap">
				Input your estimate line below and hit analyze to enter the variations
			</div>
			<div className="justify-start items-start inline-flex min-w-[800px] w-full">
				<div className="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
					<div className="self-stretch h-11 flex-col justify-start items-start gap-1.5 flex">
						<div className="self-stretch px-3.5 py-2.5 bg-white rounded-tl-lg rounded-bl-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex">
							<div className="grow shrink basis-0 h-6 justify-start items-center gap-2 flex">
								<input
									onKeyUp={(e) => {
										if (e.key === "Enter") {
											onProcess();
										}
									}}
									placeholder="Enter line item"
									value={inputValue}
									onChange={(e) => onInputChange(e.target.value)}
									type="text"
									className="w-full"
								/>
							</div>
						</div>
					</div>
				</div>
				<div
					onClick={onProcess}
					className="w-[121px] px-8 py-2.5 bg-sky-50 rounded-tr-lg rounded-br-lg border border-sky-50 justify-center items-center gap-2 flex cursor-pointer"
				>
					<div className="text-blue-700 text-base font-semibold font-['Hanken Grotesk'] leading-normal ">Process</div>
				</div>
			</div>
		</div>
	);
};

export default LineItemTopInput;
